import { Bar } from 'public/charting_library/charting_library';

export interface BybitHistoricalData {
  retCode: number;
  retMsg: string;
  result: Result;
  time: number;
}

export interface Result {
  category: string;
  symbol: string;
  list: string[][];
}

// https://bybit-exchange.github.io/docs/v5/market/kline
export async function getHistoricalData(opts: {
  symbol: string;
  interval: string;
  limit: number;
  from?: number;
  to?: number;
}): Promise<Bar[]> {
  console.debug('[BYBIT]', '-- getHistoricalData', opts);
  const queryParams: Record<string, any> = {
    symbol: opts.symbol,
    limit: opts.limit,
    interval: opts.interval,
    end: opts?.to,
    start: opts.from,
    category: 'spot',
  };

  const params = new URLSearchParams(queryParams);
  const url = `https://api.bybit.com/v5/market/kline?${params.toString()}`;
  console.debug('[BYBIT]', 'request historical data', url);

  const resp = await fetch(url);
  if (!resp.ok) {
    throw new Error('Fail to get historical data');
  }

  const data: BybitHistoricalData = await resp.json();

  if (data.retCode !== 0) {
    throw new Error(data.retMsg);
  }

  const returnData = data.result.list.map((o) => {
    const ele: Bar = {
      time: parseInt(o[0], 10),
      open: parseFloat(o[1] || '0'),
      high: parseFloat(o[2] || '0'),
      low: parseFloat(o[3] || '0'),
      close: parseFloat(o[4] || '0'),
    };

    return ele;
  });

  returnData.sort((prev, next) => prev.time - next.time);

  return returnData;
}
